import { useState } from "react";
import constants from "../constants/constants";

export default function ContactForm() {
  const [popup, setPopup] = useState(false);
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    message: "",
    consent: false,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  async function submitForm(event) {
    event.preventDefault();

    const data = {
      ...formData,
      access_key: constants.EMAIL_ACCESS_KEY,
      subject: "New Review Form Message",
    };

    console.log("data", data);

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      const response = await res.json();

      if (response?.success) {
        console.log("Success", response);
        setPopup({
          subject: "Thanks for your message!",
          message: "We will get back to you as soon as possible",
        });
        // Clear form after successful submission
        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          phoneNumber: "",
          message: "",
          consent: false,
        });
      } else {
        setPopup({
          subject: "We encountered an error in sending this message",
          message: "Please try again later",
        });
      }
    } catch (err) {
      console.log(err);
      setPopup({
        subject: "We encountered an error in sending this message",
        message: "Please try again later",
      });
    }
  }

  return (
    <section id="contact" className="py-20 px-6 max-w-4xl mx-auto">
      <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <input
          className="review-form-input"
          placeholder="First Name*"
          name="firstname"
          value={formData.firstname}
          onChange={handleInputChange}
          required />

        <input
          className="review-form-input"
          placeholder="Last Name*"
          name="lastname"
          value={formData.lastname}
          onChange={handleInputChange}
          required
        />
        <input
          className="review-form-input md:col-span-2"
          placeholder="Phone*"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleInputChange}
          required
        />
        <input
          className="review-form-input md:col-span-2"
          placeholder="Email*"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          required
        />

        <textarea
          className="review-form-input md:col-span-2"
          placeholder="How can I help you with your real estate journey?"
          rows={4}
          name="message"
          value={formData.message}
          onChange={handleInputChange}
          required
        />

        <label className="md:col-span-2 flex items-center gap-2 text-black font-light">
          <input type="checkbox"
            name="consent"
            checked={formData.consent}
            onChange={(e) =>
              setFormData({
                ...formData,
                consent: e.target.checked,
              })} />
          Yes, I agree to be contacted and receive helpful emails and understand I can unsubscribe at anytime.
        </label>

        <div className="w-full ml-auto">
          <button
            type="submit"
            className="btn-secondary px-10 uppercase tracking-wider"
          >
            Submit
          </button>
        </div>
      </form>
    </section>
  )
}